import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Building2, ArrowLeft } from 'lucide-react';
import { vendorFetch } from '../../contexts/VendorAuthContext';

export default function VendorRegister() {
  const nav = useNavigate();
  const [form, setForm] = useState({ company_name: '', contact_name: '', email: '', phone: '', password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { toast.error('Passwords do not match'); return; }
    if (form.password.length < 8) { toast.error('Password must be at least 8 characters'); return; }
    setLoading(true);
    try {
      await vendorFetch('/partner/auth/register', {
        method: 'POST',
        body: JSON.stringify({ company_name: form.company_name, contact_name: form.contact_name, email: form.email, phone: form.phone, password: form.password }),
      });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Registration failed');
    } finally { setLoading(false); }
  };

  if (done) return (
    <div className="min-h-screen bg-[#3b4872] flex items-center justify-center px-4">
      <div className="bg-white rounded-sm shadow-2xl max-w-md w-full p-8 text-center space-y-4">
        <div className="text-2xl font-bold text-slate-900">Check your email</div>
        <p className="text-slate-600 text-sm">We sent a verification link to <strong>{form.email}</strong>. Click it to activate your account.</p>
        <Link to="/partner/login" className="inline-block text-[#3b4872] font-bold text-sm hover:underline">Go to Login →</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#3b4872] flex flex-col items-center justify-center px-4 py-10" data-testid="vendor-register-page">
      <div className="bg-white rounded-sm shadow-2xl w-full max-w-md p-8 space-y-5">
        <div className="flex items-center gap-3">
          <img src="/ellora-logo-blue.png" alt="Ellora EPC" className="h-9 w-auto" />
          <div className="border-l border-slate-200 pl-3">
            <div className="font-bold text-sm text-slate-900">Register as Partner</div>
            <div className="text-[10px] text-slate-400">Ellora EPC Vendor Portal</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          {[
            { key: 'company_name', label: 'Company Name *', type: 'text', placeholder: 'ABC Supplies Pvt Ltd' },
            { key: 'contact_name', label: 'Your Name *', type: 'text', placeholder: 'Ramesh Patel' },
            { key: 'email', label: 'Work Email *', type: 'email', placeholder: 'you@company.com' },
            { key: 'phone', label: 'Phone', type: 'tel', placeholder: '+91 98765 43210' },
            { key: 'password', label: 'Password *', type: 'password', placeholder: 'Min 8 characters' },
            { key: 'confirm', label: 'Confirm Password *', type: 'password', placeholder: '' },
          ].map(({ key, label, type, placeholder }) => (
            <div key={key}>
              <label className="block text-xs font-semibold text-slate-600 mb-1">{label}</label>
              <input type={type} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })}
                placeholder={placeholder}
                className="w-full border border-slate-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-[#3b4872]"
                required={!['phone'].includes(key)} data-testid={`reg-${key}`} />
            </div>
          ))}
          <button type="submit" disabled={loading}
            className="w-full bg-[#3b4872] hover:bg-[#2e3a5c] text-white py-2.5 rounded font-bold text-sm disabled:opacity-50 mt-2"
            data-testid="reg-submit-btn">
            {loading ? 'Registering…' : 'Create Account'}
          </button>
        </form>
        <div className="text-center text-xs text-slate-500">
          Already registered? <Link to="/partner/login" className="text-[#3b4872] font-semibold hover:underline">Sign in</Link>
        </div>
        <div className="border-t pt-3 text-center">
          <Link to="/" className="text-xs text-slate-400 hover:text-slate-600 flex items-center justify-center gap-1"><ArrowLeft size={12} /> Back to Ellora EPC</Link>
        </div>
      </div>
    </div>
  );
}
